import { Product } from "operations/schema/schema";

export const products = Object.entries(Product)
  .reduce((p: any[], [key, value]) => [...p, { key, value }], [])
  .filter((p) => p.value !== "MOCK" && p.value !== "VANTAGE_ONLINE_STAGE");

export const productsPretty = (val: string): string =>
  products.find((kv) => kv.value === val)?.key || "";
